export const SSO_COOKIE_KEYS = {
    CLOUDFLARE_ACCESS: 'CF_Authorization',
} as const;
